export const setAssinaturaConcluidaModalOpened = state => {
    return dispatch => {
        dispatch({ type: "SET_ASSINATURA_CONCLUIDA_MODAL_OPENED", payload: state });
    };
}